/* ══════════════════════════════════════════════════════════════════════════
   LG GALLERY VIDEOS — click-to-play de vídeos (YouTube/TikTok) inyectados
   en la galería del producto.
   Marcado: snippets/lg-gallery-videos.liquid · Estilos: lg-gallery-videos.css
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function stopVideo(container) {
    var iframe = container.querySelector('iframe.lg-gv-iframe');
    if (iframe) iframe.remove();
    container.classList.remove('is-playing');
  }

  function playVideo(button) {
    var container = button.closest('.lg-gv');
    if (!container || container.classList.contains('is-playing')) return;
    if (window.pauseAllMedia) window.pauseAllMedia();

    var iframe = document.createElement('iframe');
    iframe.src = button.dataset.lgvEmbed;
    iframe.className = 'lg-gv-iframe';
    // js-youtube: permite que pauseAllMedia() de Dawn pause el vídeo vía postMessage.
    if (button.dataset.lgvPlatform === 'youtube') iframe.classList.add('js-youtube');
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', button.getAttribute('aria-label') || 'Vídeo del producto');
    container.querySelector('.lg-gv-media').appendChild(iframe);
    container.classList.add('is-playing');
  }

  document.addEventListener('click', function (event) {
    var playButton = event.target.closest('[data-lgv-embed]');
    if (playButton) {
      playVideo(playButton);
      return;
    }
    // Al pulsar una miniatura de otra slide, desmontar los vídeos en reproducción
    // (en escritorio con layout thumbnail el slider no dispara slideChanged).
    var thumb = event.target.closest('.thumbnail-list__item[data-target]');
    if (thumb) {
      document.querySelectorAll('.lg-gv.is-playing').forEach(function (container) {
        var slide = container.closest('[data-media-id]');
        if (!slide || slide.dataset.mediaId !== thumb.dataset.target) stopVideo(container);
      });
    }
  });

  // slideChanged no burbujea: se escucha en fase de captura a nivel de documento,
  // lo que además sobrevive a los re-renders de sección al cambiar de variante.
  document.addEventListener(
    'slideChanged',
    function (event) {
      var viewer = event.target;
      if (!viewer.id || viewer.id.indexOf('GalleryViewer') !== 0) return;
      var current = event.detail && event.detail.currentElement;
      if (!current) return;
      viewer.querySelectorAll('.lg-gv.is-playing').forEach(function (container) {
        if (!current.contains(container)) stopVideo(container);
      });
    },
    true
  );
})();

